const Scroll = () => {
	const animationWrapper = document.querySelector(
		".single-product-top-wrapper-image-animation"
	);

    if(window.innerWidth > 1023) {
        if (animationWrapper) {
            const animationDuration = 1000; // Czas trwania animacji w milisekundach
            let isScrollHandled = false; // Zmienna do śledzenia, czy animacja została wykonana
            let animationTimeout;
    
            // Funkcja do pobrania szerokości scrollbara
            const getScrollbarWidth = () => {
                return window.innerWidth - document.documentElement.clientWidth;
            };
    
            // Event na scroll
            window.addEventListener("scroll", function () {
                // Sprawdzamy, czy animacja już została wykonana, jeśli tak - nie robimy nic
                if (isScrollHandled) {
                    return;
                }
    
                // Dodajemy klasę 'scroll-blocked' przy rozpoczęciu scrolla
                const bodyElement = document.querySelector("body.single-product");
                const scrollbarWidth = getScrollbarWidth(); // Pobranie szerokości scrollbara
    
                // Dodajemy padding równy szerokości scrollbara, aby zapobiec skakaniu strony
                bodyElement.style.paddingRight = `${scrollbarWidth}px`;
                bodyElement.classList.add("scroll-blocked");
    
                // Ustawiamy zmienną, aby zapobiec ponownemu uruchomieniu animacji
                isScrollHandled = true;
    
                // Usunięcie klasy 'scroll-blocked' i dodanie 'scroll-animation-end' po czasie animacji
                animationTimeout = setTimeout(() => {
                    bodyElement.classList.remove("scroll-blocked");
                    bodyElement.classList.add("scroll-animation-end");
    
                    // Przywrócenie oryginalnego paddingu
                    bodyElement.style.paddingRight = ""; // Resetujemy padding
                }, animationDuration);
            });
        }
    }

};

export default Scroll;
